// extracted by mini-css-extract-plugin
export var sliderRange = "_n2-2";
export var sliderRoot = "_n2-0";
export var sliderThumb = "_n2-3";
export var sliderTrack = "_n2-1";